/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EsercenteComuneRiferimentoDTO } from './esercente-comune-riferimento-dto';


export interface EsercenteProfiloSchedaDTO { 
    profilo_id?: string;
    user_id?: string;
    version?: number;
    email?: string;
    ragione_sociale?: string;
    partita_iva?: string;
    pec?: string;
    sede_legale?: string;
    indirizzo_sede?: string;
    iban?: string;
    cciaa?: string;
    stato?: EsercenteProfiloSchedaDTOStatoEnum;
    account_attivato?: boolean;
    account_abilitato?: boolean;
    bloccato_da_amministrazione?: boolean;
    comune_riferimento?: EsercenteComuneRiferimentoDTO;
    creato_da_operatore?: boolean;
    numero_negozi?: number;
    numero_cassieri?: number;
    numero_domande?: number;
    puo_modificare_dati?: boolean;
    anonimizzato_il?: string;
}
export enum EsercenteProfiloSchedaDTOStatoEnum {
    BLOCCATO_DA_BACKOFFICE = 'BLOCCATO_DA_BACKOFFICE',
    EMAIL_NON_VERIFICATA = 'EMAIL_NON_VERIFICATA',
    IN_ATTESA_DI_ATTIVAZIONE = 'IN_ATTESA_DI_ATTIVAZIONE',
    ATTIVO = 'ATTIVO'
};



